import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/layer/category/layer.category.query.gql"
import type {
  LayerCategoryQuery,
  LayerCategoryQueryVariables,
} from "@/v2-backoffice-client/layer/category/__types__/layer.category.query"

type Options = QueryHookOptions<LayerCategoryQuery, LayerCategoryQueryVariables>

export function useLayerCategoryQuery(options?: Options) {
  return useQuery<LayerCategoryQuery, LayerCategoryQueryVariables>(
    query,
    options,
  )
}
